<template functional>
  <div class="noWrap">
    {{ props.value.join(', ') }}
  </div>
</template>

<script>
export default {
  name: 'DataTableTextColumn',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
